import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState, useRef } from 'react';
import UserOnglet from "../../user/UserOnglet";
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicAvatar = () => {
  const { setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/help'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Que vous soyez en train de vous inscrire à une compétition ou que vous constituiez une équipe, une photo de profil nette et identifiable peut faire 
              toute la différence. Lors de la sélection des coéquipiers dans une liste déroulante, une photo de profil permet non seulement de gagner en rapidité 
              et de simplicité. Contribuez à rendre l’expérience encore plus fluide et authentique grâce à votre photo !
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32" >
                    <p className="help-subtitle-part">Modifier votre photo depuis un ordinateur</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Profil</strong> {'>'} 
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Modifier mon profil.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté de votre photo de profil, cliquez sur <strong>le crayon</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Ajoutez une photo, puis cliquez sur <strong>Enregistrer</strong>.</p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Modifier votre photo sur un navigateur mobile</p>
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez dans le navbar sur votre <strong>Avatar</strong> ou sur <i className="fa-solid fa-bars fz-18 ml-8 mr-8"></i> {'>'} 
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>Mon Compte.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Dans Paramètres du compte {'>'} <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Informations personnelles.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">À côté de votre photo de profil, cliquez sur <strong>le crayon</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Sélectionnez <strong>Bibliothèque de photos</strong> ou <strong>Prendre une photo</strong>.</p></li>
                      <li className="pl-8 mb-8"><p className="help-text">Ajoutez une photo, puis cliquez sur <strong>Enregistrer</strong>.</p></li>
                    </ol>
                  </div>
              }
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Lorsque vous sélectionnez votre photo de profil, notre système de capture guidée par IA vérifie automatiquement qu'elle respecte 
                les critères de notre Politique en matière de contenus.
              </p>
              <p className="help-text">Voici quelques-uns des conseils possibles :</p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Zoomer automatiquement pour centrer votre visage dans le cadre.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Choisir une photo où vous êtes facilement identifiable et mis en avant si la photo comporte plusieurs personnes.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Choisir une photo où votre visage fait face à l'appareil photo.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Vérifiez que votre photo n'est pas floue.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Il est déconseillé d'ajouter une image qui ne vous représente pas du tout, comme la photo d'un paysage ou d'un animal.</p></li>
              </ul>
              <p className="help-text mt-32">
                Ces conseils sont facultatifs. Si vous préférez, vous pouvez ignorer nos recommandations et ajouter la photo de votre choix. 
                Assurez-vous simplement qu'elle respecte les critères de la<a target='_blank' className="link" href="#">Politique en matière de contenus.</a>
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">
                Votre de profil sera visible uniquement au moment de l’inscription à une compétition, lorsque d’autres membres de Wodzone 
                composeront une équipe. Elle sera affichée aux côtés du nom, prénom et club, permettant ainsi aux coéquipiers de s’identifier 
                plus facilement.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicAvatar